(function () {
  if (window.elsgrgCartSyncInstalled) return;
  window.elsgrgCartSyncInstalled = true;

  var SERVICE_MARKER_PROPERTY = '_addition_to';
  var SERVICE_PARENT_PROPERTY = '_parent_variant_id';
  var SERVICES_ATTRIBUTE_NAME = 'services';
  var CART_CHANGE_PATH = '/cart/change.js';

  var originalFetch = window.fetch.bind(window);

  function getRootUrl() {
    return (window.routes && window.routes.rootUrlWithoutSlash) || '';
  }

  function getCartUrl() {
    return getRootUrl() + '/cart.js';
  }

  function getCartUpdateUrl() {
    return getRootUrl() + '/cart/update.js';
  }

  function isCartChangeRequest(requestUrl, requestMethod) {
    if (typeof requestUrl !== 'string') return false;
    if (String(requestMethod || 'GET').toUpperCase() !== 'POST') return false;
    return requestUrl.split('?')[0].indexOf(CART_CHANGE_PATH, requestUrl.length - CART_CHANGE_PATH.length) !== -1;
  }

  function isServiceItem(item) {
    return !!(item && item.properties && item.properties[SERVICE_MARKER_PROPERTY]);
  }

  function findTargetItem(cartItems, requestPayload) {
    if (requestPayload.line !== undefined && requestPayload.line !== null) {
      return cartItems[parseInt(requestPayload.line, 10) - 1] || null;
    }

    if (requestPayload.id !== undefined && requestPayload.id !== null) {
      var requestedId = String(requestPayload.id);
      var itemByKey = cartItems.filter(function (item) { return item.key === requestedId; })[0];
      if (itemByKey) return itemByKey;
      return cartItems.filter(function (item) { return String(item.variant_id) === requestedId; })[0] || null;
    }

    return null;
  }

  function buildUpdates(cartItems, targetItem, quantity) {
    var updates = {};
    updates[targetItem.key] = quantity;

    if (isServiceItem(targetItem)) return updates;

    cartItems.forEach(function (item) {
      if (!isServiceItem(item)) return;
      if (String(item.properties[SERVICE_PARENT_PROPERTY]) !== String(targetItem.variant_id)) return;
      updates[item.key] = quantity;
    });

    return updates;
  }

  function buildRemainingServices(cartAttributes, cartItems, updates) {
    var services = [];

    try {
      services = JSON.parse(cartAttributes && cartAttributes[SERVICES_ATTRIBUTE_NAME]);
    } catch (error) {
      return null;
    }

    if (!Array.isArray(services) || !services.length) return null;

    var removedVariantIds = cartItems
      .filter(function (item) { return isServiceItem(item) && updates[item.key] === 0; })
      .map(function (item) { return item.variant_id; });

    if (!removedVariantIds.length) return null;

    var pendingVariantIds = removedVariantIds.slice();
    var remainingServices = services.filter(function (service) {
      var matchIndex = pendingVariantIds.indexOf(service.variantId);
      if (matchIndex === -1) return true;
      pendingVariantIds.splice(matchIndex, 1);
      return false;
    });

    if (remainingServices.length === services.length) return null;

    return JSON.stringify(remainingServices);
  }

  function sendCartUpdate(updateBody) {
    return originalFetch(getCartUpdateUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(updateBody)
    });
  }

  function syncCartChange(requestUrl, requestInit) {
    var requestPayload = null;

    try {
      requestPayload = JSON.parse(requestInit.body);
    } catch (error) {
      return originalFetch(requestUrl, requestInit);
    }

    if (!requestPayload || requestPayload.quantity === undefined) {
      return originalFetch(requestUrl, requestInit);
    }

    return originalFetch(getCartUrl(), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (cartResponse) {
        if (!cartResponse.ok) return null;
        return cartResponse.json();
      })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) return originalFetch(requestUrl, requestInit);

        var targetItem = findTargetItem(cart.items, requestPayload);
        if (!targetItem) return originalFetch(requestUrl, requestInit);

        var quantity = parseInt(requestPayload.quantity, 10);
        if (isNaN(quantity)) return originalFetch(requestUrl, requestInit);

        var updates = buildUpdates(cart.items, targetItem, quantity);
        var remainingServices = buildRemainingServices(cart.attributes, cart.items, updates);

        if (Object.keys(updates).length === 1 && remainingServices === null) {
          return originalFetch(requestUrl, requestInit);
        }

        var updateBody = { updates: updates };

        if (remainingServices !== null) {
          updateBody.attributes = {};
          updateBody.attributes[SERVICES_ATTRIBUTE_NAME] = remainingServices;
        }

        return sendCartUpdate(updateBody);
      })
      .catch(function () {
        return originalFetch(requestUrl, requestInit);
      });
  }

  window.fetch = function (requestUrl, requestInit) {
    if (!requestInit || typeof requestInit.body !== 'string' || !isCartChangeRequest(requestUrl, requestInit.method)) {
      return originalFetch(requestUrl, requestInit);
    }

    return syncCartChange(requestUrl, requestInit);
  };
})();
